export const assert = (t, message = 'AssertError') => {
    if (!t) {
        throw new Error(message, { cause: t });
    }
    return t;
};
//# sourceMappingURL=assert.js.map